import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LandingComponent } from './landing.component';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { LoanrenewalYesNoComponent } from './loanrenewal-yes-no/loanrenewal-yes-no.component';
import { ConsentFormWebComponent } from './loanrenewal-yes-no/consent-formweb.component';
 
const routes: Routes = [
  {
    path: '', component: LandingComponent, children: [
      { path: 'login-admin', component: LoginAdminComponent },
      { path: 'reset-password', component: ResetpasswordComponent },
      // { path: 'login-team', component: LoginTeamComponent }, not used anymore
      { path: 'loanrenewal_consent/:id', component: LoanrenewalYesNoComponent },
      { path: 'loanrenewal_web/:id', component: ConsentFormWebComponent },
      { path: 'loanrenewal_consent/', component: LoanrenewalYesNoComponent },
      { path: 'loanrenewal_web/', component: ConsentFormWebComponent },
      // { path: 'register', component: RegisterComponent },
      { path: '', redirectTo: '/login-admin', pathMatch: 'full' },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
